<template>
  <div style="padding: 0 20px">
    <h2 style="text-align: center">{{ form.title }}</h2>
    <p style="text-indent: 2em">{{ form.content }}</p>
    <a-divider orientation="left">项目详情</a-divider>
    <a-collapse v-model="activeKey" v-for="(item, index) in data" :key="item.id">
      <a-collapse-panel :key="index" :header="`计划回款时间${item.backDate}(已超期)`">
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">项目名称:</a-col>
          <a-col :span="12">{{ item.projectName }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">合同订单:</a-col>
          <a-col :span="12">{{ item.contractName }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">项目负责人:</a-col>
          <a-col :span="12">{{ item.dutyPerson }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">客户:</a-col>
          <a-col :span="12">{{ item.customerName }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">回款金额(元):</a-col>
          <a-col :span="12">{{ item.backMoney }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">计划回款时间:</a-col>
          <a-col :span="12">{{ item.backDate }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">期次:</a-col>
          <a-col :span="12">{{ item.period }}</a-col>
        </a-row>
        <a-row class="l-row">
          <a-col :span="12" class="colTitle">已开发票:</a-col>
          <a-col :span="12">
            <span v-if=" item.backInvoice === 0">否</span>
            <span v-else-if=" item.backInvoice === 1">
              <a-icon type="check-square" theme="twoTone" two-tone-color="#52c41a" />
            </span>
          </a-col>
        </a-row>
      </a-collapse-panel>
    </a-collapse>
    <a-divider orientation="left">消息回复</a-divider>
    <a-form-model-item label="回复内容" prop="content">
      <a-textarea
        :read-only="!flag"
        :auto-size="{ minRows: 1, maxRows: 10 }"
        style="width: 100%;"
        v-model="replyContent"
      />
    </a-form-model-item>
    <div class="footer_right" v-if="flag">
      <a-button :loading="loading" @click="close">关 闭</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk">确认回复</a-button>
    </div>
  </div>
</template>

<script>
import * as dd from 'dingtalk-jsapi'
export default {
  name: 'yskhz',
  data () {
    return {
      form: {},
      data: [],
      activeKey: '0',
      replyContent: '',
      loading: false,
      flag: true
    }
  },
  mounted () {
    this.initData(this.$route.query.id)
  },
  methods: {
    initData (id) {
      this.$get('/payFeedback/getById', { id }).then(res => {
        if (res.data.status === 1) {
          this.form = res.data.data
          this.flag = this.form.replyContent === null
          if (this.form.replyContent) {
            this.replyContent = this.form.replyContent
          }
          this.initJh()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    initJh () {
      this.$get('/payBack/list', { projectId: this.form.projectId, backStatus: 0, pageNum: 1, pageSize: 50, backType: 0 }).then(res => {
        if (res.data.status === 1) {
          this.data = res.data.data.rows.slice(0, 1)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    handleOk () {
      this.loading = true
      this.$post('/payFeedback/reply', { replyContent: this.replyContent, id: this.form.id }).then(res => {
        if (res.data.status === 1) {
          this.$message.success('发送成功！请勿重复发送')
          setTimeout(() => {
            this.close()
          }, 500)
        } else {
          this.$message.warning(res.data.message)
        }
      }).finally(_ => {
        this.loading = false
      })
    },
    close () {
      const userAgent = navigator.userAgent
      // // 判断是否在 PC 端钉钉
      let isPcDingTalk = /DingTalk/i.test(userAgent) && /Windows/i.test(userAgent)
      // // 判断是否在手机移动端钉钉
      let isMobileDingTalk = /DingTalk/i.test(userAgent) && /Mobile/i.test(userAgent)
      if (isPcDingTalk) {
        dd.quitPage()
      }
      if (isMobileDingTalk) {
        // eslint-disable-next-line no-undef
        dd.closePage()
      }
    }
  }
}
</script>

<style scoped>
.footer_right {
  text-align: center;
}
.l-row {
  padding: 10px;
  border-bottom: 1px dashed #ccc;
}
.colTitle {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/AccountsReceivableStatisticsTable/yskhz.vue